import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * A real QR code for `value`, drawn as SVG with rounded finder squares (the look Sam picked on the lab's placeholder).
 * Error correction Q: still reads with a scuffed screen or a glare spot.
 */
export default function PriiQr({ value, size = 200, className = '' }) {
  const { n, cells } = useMemo(() => {
    const qr = qrcode(0, 'Q');
    qr.addData(value);
    qr.make();
    const count = qr.getModuleCount();
    const inFinder = (x, y) =>
      (x < 7 && y < 7) || (x >= count - 7 && y < 7) || (x < 7 && y >= count - 7);
    const out = [];
    for (let y = 0; y < count; y++)
      for (let x = 0; x < count; x++) if (!inFinder(x, y) && qr.isDark(y, x)) out.push([x, y]);
    return { n: count, cells: out };
  }, [value]);
  const F = ({ x, y }) => (
    <g>
      <rect x={x} y={y} width="7" height="7" rx="1.8" />
      <rect x={x + 1} y={y + 1} width="5" height="5" rx="1.2" fill="#fff" />
      <rect x={x + 2} y={y + 2} width="3" height="3" rx=".9" />
    </g>
  );
  return (
    <svg
      viewBox={`-2 -2 ${n + 4} ${n + 4}`}
      width={size}
      height={size}
      className={`pp-qr ${className}`}
      role="img"
      aria-label="Your Prii code"
    >
      <rect x="-2" y="-2" width={n + 4} height={n + 4} rx="3" fill="#fff" />
      <g fill="#1b1426" shapeRendering="crispEdges">
        {cells.map(([x, y]) => (
          <rect key={`${x}-${y}`} x={x} y={y} width="1.02" height="1.02" />
        ))}
      </g>
      <g fill="#1b1426">
        <F x={0} y={0} />
        <F x={n - 7} y={0} />
        <F x={0} y={n - 7} />
      </g>
    </svg>
  );
}
